const keywords = [
  "backup",
  "map-to-fo",
  "iot-fields",
  "calculated-fields",
  "alarm",
  "event",
  "v2",
];

export default keywords;
